import { h } from '../pragma.mjs';
import { settings } from '../../config/settingsFactory.mjs';
import { getValidSetting } from '../../utils/common.mjs';

export default (isPublic) => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#" class="no-focus-change">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Další ... </strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles role="list">
                <gov-tile role="listitem" href={isPublic ? getValidSetting(settings.urls?.NV?.public, '#', 'NV link public') : getValidSetting(settings.urls?.NV?.private, '#', 'NV link private')} target="_blank">
                    <p>Zápis vymezení nových bytových a nebytových jednotek</p>
                    <h3 slot="title">Zápis nových jednotek&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="cities" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikDalsiS8409" href="#">
                    <p>Uložení úplného znění prohlášení vlastníka domu nebo dohody spoluvlastníků o správě nemovitosti do sbírky listin</p>
                    <h3 slot="title">Uložení úplného znění prohlášení nebo dohody do sbírky listin</h3>
                    <gov-icon type="complex" name="institute-file" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" id="rozcestnikDalsi2Tile" href="#">
                    <p>Změna týkající se měřických značek bodů polohového pole</p>
                    <h3 slot="title">Body polohového pole</h3>
                    <gov-icon type="complex" name="map" slot="icon"></gov-icon>
                </gov-tile>
                <gov-tile role="listitem" href={(isPublic) ? "https://nv.cuzk.gov.cz/" : "/nv?akce=VytvorNavrh"} target="_blank">
                    <p>Výhrada vlastnického práva, zpětné koupě, zpětného prodeje, lepšího kupce, ujednání o koupi na zkoušku ...</p>
                    <h3 slot="title">Výhrady&nbsp;<gov-icon class="h3icon" type="basic" name="box-arrow-up-right"></gov-icon></h3>
                    <gov-icon type="complex" name="quotes" slot="icon"></gov-icon>
                </gov-tile>
            </gov-tiles>
        </div>
    )

}